import { Box } from '@mui/material'
import ComposerEditor from './composerEditor/ComposerEditor'
import styles from './index.module.scss'

export default function AiAskBarHomeComposerEditor({
  composerEditorRef,
  inputPlaceholder,
  isDictating,
  isExpanded,
  textareaMaxHeightPx,
  setComposerPlainText,
  handleComposerEnter,
}) {
  if (isDictating && !isExpanded) return null

  return (
    <Box className={styles.textWrap}>
      <ComposerEditor
        ref={composerEditorRef}
        placeholder={inputPlaceholder}
        readOnly={isDictating}
        textareaMaxHeightPx={textareaMaxHeightPx}
        onPlainTextChange={setComposerPlainText}
        onEnterSubmit={handleComposerEnter}
        editorAriaLabel={inputPlaceholder}
      />
    </Box>
  )
}
